import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../services/security/authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private oAuthenticationService: AuthenticationService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.oAuthenticationService.isAuthenticated()) {
            // logged in so return true
            console.log('AuthGuard is Authentic true');
            return true;
        } else {
            console.log('AuthGuard is Authentic false');
            localStorage.clear();
            // not logged in so redirect to login page with the return url
            this.router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url } });
            return false;
        }
    }
}